/* FIX_HEADING_NOWRAP_SHRINK_2026_07_17 (Task3)
   Shrink-to-fit for headings that must never wrap onto a 2nd line, especially
   on narrow mobile widths. Instead of guessing a font-size with CSS clamp(),
   this measures the real rendered text width against the available container
   width and reduces font-size in small steps until it fits on one line, with
   a floor so it never becomes unreadably tiny (falls back to normal wrapping
   below that floor rather than going smaller).

   Usage: window.seNowrapFit(['.some-heading-selector', '.another-one'])
   Safe to call multiple times (idempotent) and re-runs on resize/orientation
   change (debounced) so it keeps fitting across breakpoints and rotation.
*/
(function () {
  var MIN_FONT_PX = 11;   // never shrink below this - falls back to wrapping instead
  var STEP_PX = 0.5;

  function fitOne(el) {
    if (!el || !el.isConnected) return;

    // Reset to natural size first so we measure from a clean baseline each run
    // (important on resize - a previous shrink shouldn't compound).
    if (!el.dataset.nowrapFitOriginalSize) {
      el.dataset.nowrapFitOriginalSize = parseFloat(getComputedStyle(el).fontSize);
    }
    var originalSize = parseFloat(el.dataset.nowrapFitOriginalSize);
    el.style.whiteSpace = 'nowrap';
    el.style.fontSize = originalSize + 'px';

    var guard = 0;
    while (el.scrollWidth > el.clientWidth && parseFloat(el.style.fontSize) > MIN_FONT_PX && guard < 200) {
      el.style.fontSize = (parseFloat(el.style.fontSize) - STEP_PX) + 'px';
      guard++;
    }

    // If even the floor size still overflows, give up gracefully and let it
    // wrap rather than clip or run unreadably small - matches the "drop size,
    // don't wrap unless truly forced to" ask.
    if (el.scrollWidth > el.clientWidth) {
      el.style.whiteSpace = 'normal';
    }
  }

  function fitAll(selectors) {
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(fitOne);
    });
  }

  var lastSelectors = [];
  var resizeTimer = null;

  window.seNowrapFit = function (selectors) {
    lastSelectors = selectors || [];
    fitAll(lastSelectors);

    if (!window.__seNowrapFitBound) {
      window.__seNowrapFitBound = true;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { fitAll(lastSelectors); }, 150);
      });
      window.addEventListener('orientationchange', function () {
        setTimeout(function () { fitAll(lastSelectors); }, 200);
      });
      // Web fonts loading after initial paint can change measured widths.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { fitAll(lastSelectors); });
      }
    }
  };
})();
